class EnrollmentManager {
  constructor() {
    this.selectedCourses = new Map();
    this.selectedGrade = null;
    this.showAllCourses = false;
    this.init();
  }

  init() {
    // Listen for grade selection
    const gradeSelect = document.getElementById('student-grade');
    if (gradeSelect) {
      gradeSelect.addEventListener('change', (e) => {
        this.selectedGrade = parseInt(e.target.value);
        this.loadDefaultBundle();
        this.filterCourses();
      });
    }

    // Listen for show all toggle
    const showAllToggle = document.getElementById('show-all-courses');
    if (showAllToggle) {
      showAllToggle.addEventListener('change', (e) => {
        this.showAllCourses = e.target.checked;
        this.filterCourses();
      });
    }

    // Listen for review button
    const reviewBtn = document.getElementById('review-enrollment');
    if (reviewBtn) {
      reviewBtn.addEventListener('click', () => this.goToReview());
    }

    // Initialize course card listeners
    this.initializeCourseCards();
  }

  initializeCourseCards() {
    document.querySelectorAll('.enroll-course-card').forEach(card => {
      const checkbox = card.querySelector('.enroll-course-card__checkbox');
      if (checkbox) {
        checkbox.addEventListener('change', (e) => {
          const productId = card.dataset.productId;
          if (e.target.checked) {
            this.addCourse(card);
          } else {
            this.removeCourse(productId);
          }
        });
      }
    });
  }

  loadDefaultBundle() {
    if (!this.selectedGrade) return;

    const bundles = {
      9: ['English 9', 'Algebra I', 'Biology', 'World History', 'Health'],
      10: ['English 10', 'Geometry', 'Chemistry', 'U.S. History', 'Spanish I'],
      11: ['English 11', 'Algebra II', 'Physics', 'Government', 'Elective'],
      12: ['English 12', 'Pre-Calculus', 'Science Elective', 'Economics', 'Elective']
    };

    const recommendedCourses = bundles[this.selectedGrade] || [];
    
    // Show bundle UI
    const bundleEl = document.getElementById('recommended-bundle');
    if (bundleEl && recommendedCourses.length > 0) {
      bundleEl.style.display = 'block';
      
      // Auto-select matching courses
      document.querySelectorAll('.enroll-course-card').forEach(card => {
        const title = card.dataset.title;
        const checkbox = card.querySelector('.enroll-course-card__checkbox');
        
        if (recommendedCourses.some(course => title.includes(course))) {
          checkbox.checked = true;
          this.addCourse(card);
        }
      });
    }
  }

  filterCourses() {
    if (!this.selectedGrade) return;

    document.querySelectorAll('.enroll-course-card').forEach(card => {
      const gradeMin = parseInt(card.dataset.gradeMin);
      const gradeMax = parseInt(card.dataset.gradeMax);
      const checkbox = card.querySelector('.enroll-course-card__checkbox');

      const inRange = this.selectedGrade >= gradeMin && this.selectedGrade <= gradeMax;

      if (this.showAllCourses) {
        card.style.display = 'block';
        checkbox.disabled = !inRange;
      } else {
        card.style.display = inRange ? 'block' : 'none';
        checkbox.disabled = false;
      }
    });
  }

  addCourse(card) {
    const courseData = {
      id: card.dataset.productId,
      title: card.dataset.title,
      credits: parseFloat(card.dataset.credits),
      price: parseFloat(card.dataset.price)
    };

    this.selectedCourses.set(courseData.id, courseData);
    this.updateSidebar();
  }

  removeCourse(productId) {
    this.selectedCourses.delete(productId);
    this.updateSidebar();
  }

  updateSidebar() {
    const selectedContainer = document.getElementById('selected-courses');
    const totalCredits = document.getElementById('total-credits');
    const totalCost = document.getElementById('total-cost');
    const warningsContainer = document.getElementById('enrollment-warnings');
    const reviewBtn = document.getElementById('review-enrollment');

    // Update selected courses list
    if (this.selectedCourses.size === 0) {
      selectedContainer.innerHTML = '<p class="enroll-sidebar__empty">No courses selected yet</p>';
    } else {
      selectedContainer.innerHTML = Array.from(this.selectedCourses.values())
        .map(course => `
          <div class="enroll-sidebar__course">
            <span>${course.title}</span>
            <span>${course.credits} cr</span>
          </div>
        `).join('');
    }

    // Calculate totals
    const credits = Array.from(this.selectedCourses.values())
      .reduce((sum, course) => sum + course.credits, 0);
    const cost = Array.from(this.selectedCourses.values())
      .reduce((sum, course) => sum + course.price, 0);

    totalCredits.textContent = credits.toFixed(1);
    totalCost.textContent = `$${cost.toFixed(2)}`;

    // Show warnings
    const warnings = [];
    if (credits > 0 && credits < 3) {
      warnings.push('Most full-time students take 4–5 courses');
    }
    if (credits > 6) {
      warnings.push('This is a heavy course load');
    }

    warningsContainer.innerHTML = warnings
      .map(w => `<div class="enroll-sidebar__warning">${w}</div>`)
      .join('');

    // Enable/disable review button
    reviewBtn.disabled = this.selectedCourses.size === 0;
  }

  goToReview() {
    // Store selection in sessionStorage
    const enrollment = {
      grade: this.selectedGrade,
      courses: Array.from(this.selectedCourses.values())
    };
    sessionStorage.setItem('enrollment', JSON.stringify(enrollment));
    
    // Navigate to review page
    window.location.href = '/pages/enroll-review';
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new EnrollmentManager());
} else {
  new EnrollmentManager();
}
